import React, { useState } from 'react';
import './OnboardingPanel.scss';
import PropTypes from 'prop-types';
import { ChevronDown, ChevronUp } from 'react-feather';
import { updateStore } from '../../api/store';
import { closeTutorial } from '../../api/owners';
import { message } from 'antd';
import { IconButton } from 'ui-kit';

const OnboardingPanel = ({
  inStore,
  inPartners,
  storeId,
  ownerId,
  title,
  children,
  isComplete,
  isClosed,
  setClosed,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleCloseForever = () => {
    setClosed(true);
    message.success({
      content: 'Hooray! Click the account icon in the top right for support anytime.',
      className: 'ShareModal_copySuccess',
      style: {
        position: 'absolute',
        top: '40px',
        width: '100%',
        fontSize: '13px',
        lineHeight: '12px',
      },
      duration: 3,
    });
    if (inStore) {
      updateStore(storeId, { hasClosedTutorial: true });
    } else {
      closeTutorial(ownerId);
    }
  };

  return (
    <>
      {!isClosed && (
        <div
          className={`OnboardingPanel${inStore ? ' inStore' : ''}${
            inPartners ? ' inPartners' : ''
          }`}
        >
          {isCollapsed ? (
            <div className="OnboardingPanel_buttonRow collapsed">
              <div className="button-box">
                <IconButton className="collapse-button" onClick={handleCollapse} color="textLight">
                  <ChevronDown />
                </IconButton>
              </div>
              <div className="OnboardingPanel_title">{title}</div>
            </div>
          ) : (
            <>
              <div className="OnboardingPanel_buttonRow">
                <div className="button-box">
                  {isComplete ? (
                    <IconButton
                      className="collapse-button close-button"
                      color="textLight"
                      onClick={handleCloseForever}
                    >
                      X
                    </IconButton>
                  ) : (
                    <IconButton
                      className="collapse-button"
                      onClick={handleCollapse}
                      color="textLight"
                    >
                      <ChevronUp />
                    </IconButton>
                  )}
                </div>
              </div>
              <div className="OnboardingPanel_content">{children}</div>
            </>
          )}
        </div>
      )}
    </>
  );
};

OnboardingPanel.propTypes = {
  inStore: PropTypes.bool,
  inPartners: PropTypes.bool,
  ownerId: PropTypes.number,
  storeId: PropTypes.number,
  title: PropTypes.string,
  children: PropTypes.any,
  isComplete: PropTypes.bool,
  isClosed: PropTypes.bool,
  setClosed: PropTypes.func,
};

OnboardingPanel.defaultProps = {
  inStore: false,
  inPartners: false,
};

export default OnboardingPanel;
